const DOMAIN =
  window.location.hostname === 'localhost' ||
  window.location.hostname === 'newadmin-dev.qualisflow.com'
    ? 'https://app-dev.qualisflow.com'
    : 'https://app.qualisflow.com'

export const RECORD = {
  VIEW: `${DOMAIN}/accounts/:accountId/projects/:projectId/:moduleName/record/:recordId`,
  EDIT: `${DOMAIN}/accounts/:accountId/projects/:projectId/:moduleName/record/:recordId/edit`
}
